import type { ReactNode } from 'react';

/**
 * O cabeçalho de página do desenho A3: rastro, título, subtítulo e ações à direita.
 *
 * <p>Um componente, e não markup repetido em doze telas — o rastro é o que diz à pessoa
 * onde ela está, e doze versões dele acabam com doze convenções diferentes de onde a
 * navegação começa.
 */
export function PageHeader({
  rastro,
  titulo,
  subtitulo,
  acoes,
}: {
  rastro?: string[];
  titulo: string;
  subtitulo?: string;
  acoes?: ReactNode;
}) {
  return (
    <div className="ph">
      {rastro && rastro.length > 0 && (
        <div className="crumb">
          {rastro.map((r, i) => (
            <span key={r}>
              {i > 0 && ' · '}
              {i === rastro.length - 1 ? <b>{r}</b> : r}
            </span>
          ))}
        </div>
      )}
      <div className="phrow">
        <div>
          <div className="t-h1">{titulo}</div>
          {subtitulo && (
            <div className="t-small" style={{ marginTop: 7, maxWidth: 620 }}>
              {subtitulo}
            </div>
          )}
        </div>
        {acoes && <div className="phacts">{acoes}</div>}
      </div>
    </div>
  );
}
